import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export async function fetchSuperAdminShareholderCompanies() {
  const res = await fetch(`${API_BASE}/api/superadmin/shareholders/companies`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الشركات'));
  const list = Array.isArray(data) ? data : [];
  return list.map((c) => ({ id: c.id, name: c.name }));
}

export async function fetchSuperAdminShareholders(params = {}) {
  const {
    page = 1,
    pageSize = 10,
    q = '',
    companyId = '',
    isActive = 'all',
    hasAccount = 'all',
    type = '',
    shareStockType = '',
    minOwnership = '',
    maxOwnership = '',
    sortBy = 'name',
    sortDir = 'asc',
  } = params;

  const query = new URLSearchParams();
  query.set('page', String(page));
  query.set('pageSize', String(pageSize));
  query.set('sortBy', sortBy);
  query.set('sortDir', sortDir);
  if (q.trim()) query.set('q', q.trim());
  if (companyId) query.set('companyId', String(companyId));
  if (isActive === 'active') query.set('isActive', 'true');
  if (isActive === 'inactive') query.set('isActive', 'false');
  if (hasAccount === 'yes') query.set('hasAccount', 'true');
  if (hasAccount === 'no') query.set('hasAccount', 'false');
  if (type.trim()) query.set('type', type.trim());
  if (shareStockType.trim()) query.set('shareStockType', shareStockType.trim());
  if (minOwnership !== '') query.set('minOwnership', String(minOwnership));
  if (maxOwnership !== '') query.set('maxOwnership', String(maxOwnership));

  const res = await fetch(`${API_BASE}/api/superadmin/shareholders?${query.toString()}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المساهمين'));

  const list = Array.isArray(data.items) ? data.items : [];
  return {
    items: list.map((s) => ({
      id: s.id,
      companyId: s.companyId,
      companyName: s.companyName ?? '',
      name: s.name ?? '',
      ownershipPercentage: Number(s.ownershipPercentage ?? 0),
      type: s.type ?? '',
      shareStockType: s.shareStockType ?? '',
      phone: s.phone ?? '',
      email: s.email ?? '',
      userName: s.userName ?? '',
      hasAccount: !!s.hasAccount,
      isActive: !!s.isActive,
    })),
    page: Number(data.page) || 1,
    pageSize: Number(data.pageSize) || pageSize,
    total: Number(data.total) || 0,
    totalPages: Number(data.totalPages) || 0,
    types: Array.isArray(data.types) ? data.types : [],
    shareStockTypes: Array.isArray(data.shareStockTypes) ? data.shareStockTypes : [],
  };
}

export async function createSuperAdminShareholder(payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/shareholders`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة المساهم'));
  return data;
}

export async function updateSuperAdminShareholder(id, payload) {
  const res = await fetch(`${API_BASE}/api/superadmin/shareholders/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث المساهم'));
  return data;
}

export async function deactivateSuperAdminShareholder(id) {
  const res = await fetch(`${API_BASE}/api/superadmin/shareholders/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر تعطيل المساهم'));
}
